import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import classNames from 'classnames';

interface IconButtonProps extends Omit<
	DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'className'
> {
	className?: string;
	icon: string;
}

export const IconButton = (props : IconButtonProps) => {
	const {
		className = '', icon, ...rest
	} = props;

	return (
		<button
			{...rest}
			className={classNames(['icon-button', `btn--icon icon-${icon}`, className])}
		>
			<span>
				{rest['aria-label']}
			</span>
		</button>
	);
};
